import { useQuery } from '@tanstack/react-query';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { ILeadSale } from '@clickersphere/core/entities/ILeadSale';
import LeadSaleService from '@clickersphere/core/services/LeadSaleService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const LEAD_SALES_QUERY_KEY = 'lead-sales';

export type LeadSaleQueryData = WithQueryStatus<ILeadSale>;

export function useLeadSales(leadId: string) {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: sales,
    isSuccess: isSalesSuccess,
    isFetching: isSalesFetching,
    isLoading: isSalesLoading,
  } = useQuery({
    queryKey: buildQueryKey([LEAD_SALES_QUERY_KEY, leadId]),
    queryFn: async () => {
      const data = await LeadSaleService.getByLead(leadId);
      return data as LeadSaleQueryData[];
    },
    enabled: !!leadId && !!selectedTenantId,
    staleTime: 1000 * 60 * 5,
  });

  return {
    sales,
    isSalesSuccess,
    isSalesFetching,
    isSalesLoading,
  };
}
